import { API_METHODS, createApiFunction } from './apiProvider'

const PATH = 'payment-configs'

export const savePaymentConfigApi = (paymentConfig) =>
  createApiFunction(API_METHODS.POST, PATH, paymentConfig, true)
